import DTM from 'shared/helpers/DTM';

export const sendPageView = (url: string) => DTM.track('page-view', { pageViewUrl: url });
